var _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconWhatsapp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 73,
    height: 75,
    viewBox: "0 0 73 75",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M54.2354 45.9718L54.5464 51.194C54.5772 51.6787 54.5063 52.1645 54.3382 52.6202C54.17 53.076 53.9084 53.4918 53.5699 53.8408C53.2315 54.1899 52.8238 54.4646 52.3729 54.6473C51.922 54.83 51.4378 54.9167 50.9514 54.9019C45.5497 54.6396 40.2851 53.1163 35.5809 50.4544C31.2075 48.0328 27.4221 44.6798 24.4937 40.6334C21.2755 36.2678 19.1332 31.2067 18.2402 25.8603C18.1679 25.3815 18.1964 24.8929 18.3237 24.4257C18.451 23.9584 18.6743 23.5227 18.9796 23.1463C19.2848 22.7699 19.6652 22.461 20.0966 22.2393C20.528 22.0177 21.0008 21.8881 21.4851 21.8588L26.7176 21.5471C27.5636 21.4884 28.402 21.7386 29.0766 22.2513C29.7512 22.7639 30.216 23.5039 30.3843 24.3334C30.7047 25.9914 31.212 27.6079 31.8966 29.1521C32.1684 29.7611 32.2595 30.4352 32.1591 31.0945C32.0588 31.7538 31.7712 32.3705 31.3305 32.8718L29.247 35.2144C31.9895 39.4245 35.82 42.8175 40.3342 45.0354L42.4176 42.6928C42.864 42.1965 43.4435 41.8383 44.0875 41.6606C44.7315 41.483 45.4129 41.4932 46.0512 41.6902C47.6687 42.1853 49.3372 42.4962 51.0249 42.6168C51.8793 42.6857 52.6784 43.0655 53.2704 43.6841C53.8623 44.3027 54.2057 45.1169 54.2354 45.9718Z",
    fill: "url(#paint0_linear_504_13)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.0001 5.42958C3.20006 13.8296 2.33339 34.2629 4.50006 43.4296L7.42394 54.1507C7.47363 54.3329 7.47071 54.5254 7.41553 54.706L2.54439 70.6479C2.31133 71.4107 3.02121 72.1259 3.78571 71.8987L20.1978 67.0194C20.3945 66.9609 20.6072 66.9656 20.8022 67.0294C34.9518 71.6588 45.3825 68.9528 48.9285 66.97C48.9781 66.9423 49.0276 66.9196 49.0809 66.9C62.223 62.0769 67.8357 49.251 69 43.4296C73.2859 22.0001 58.5 8.50011 49 5.42958C38.6043 2.06955 28.1667 3.59624 24.0001 5.42958Z",
    stroke: "url(#paint1_linear_504_13)",
    strokeWidth: 5
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_504_13",
    x1: 35.3448,
    y1: 21.0331,
    x2: 37.4109,
    y2: 55.7226,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3B438"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC907"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_504_13",
    x1: 35.8806,
    y1: 3.44165,
    x2: 35.8806,
    y2: 72.4296,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3B438"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC907"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWhatsapp);
export default __webpack_public_path__ + "static/media/icon-whatsapp.b328cec7dc79ec8994e491c2a85823e9.svg";
export { ForwardRef as ReactComponent };